'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildRequestErrorMetaObject = undefined;

var _buildErrorMetaObject = require('./buildErrorMetaObject');

/**
 * @description Display a floating alert for a request failure.
 *
 * @param {Object} options
 * @param {string} options.titleText - UIAlert title text
 * @param {node} options.message - UIAlert message
 * @param {array} options.ignoreStatusCodes - HTTP status codes for expected request failures (eg 404s)
 * @param {Error} options.error - JavaScript error
 * @return {Object} Meta Action
 *
 * @example
 * const fetchContactError = createAction(
 *   ActionTypes.GET_CONTACT_FAILED,
 *   error => ({ error }),
 *   error => buildRequestErrorMetaObject({ ignoreStatusCodes: [404], error })
 * );
 */
var buildRequestErrorMetaObject = exports.buildRequestErrorMetaObject = function buildRequestErrorMetaObject(_ref) {
  var titleText = _ref.titleText,
      message = _ref.message,
      _ref$ignoreStatusCode = _ref.ignoreStatusCodes,
      ignoreStatusCodes = _ref$ignoreStatusCode === undefined ? [] : _ref$ignoreStatusCode,
      error = _ref.error;

  var isIgnored = ignoreStatusCodes.some(function (code) {
    return code === error.status;
  });

  if (isIgnored) return (0, _buildErrorMetaObject.buildErrorMetaObject)({ ignore: true });

  return (0, _buildErrorMetaObject.buildErrorMetaObject)({ titleText: titleText, message: message });
};